// Modal.js

import React, { useRef, useState } from "react";
import DynamicTextArea from "../../DynamicTextArea";
import { useTranslation } from "react-i18next";
import { SpellDto } from "../../../Types/ApiTypes";
import { getTranslation } from "../../../Utils/Converters";
import { addSpell, deleteSpell, putSpell } from "../../../Utils/LocalApi";
import SpellModalTab from "./SpellModalTab";
import i18n from "../../../i18n";

interface SpellModalProps{
    spell: SpellDto,
    updateSpell: (spell: SpellDto)=> void,
    deleteSpell: (id?: number)=> void,
    closeModal: ()=> void
}

const SpellModal = (props: SpellModalProps) => {
    const [spell, setSpell] = useState(props.spell);
    const backgroundaRef = useRef<HTMLDivElement>(null);
    const [selectedTab, setSelectedTab] = useState(i18n.language);
    const { t } = useTranslation();


    return (
        <>{<div className="modal fs-5" tabIndex={-1} style={{display: "block"}}>
            <div 
                ref={backgroundaRef}
                className="modal-background" 
                tabIndex={-1} role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" 
                onClick={e=>{
                    if(e.target === backgroundaRef.current)
                    {
                        props.closeModal(); 
                        setSpell(props.spell)
                    }
                }}>
                <div className="modal-dialog" style={{maxWidth: "85%"}}>
                    <form className="modal-content">
                        <div className="d-flex justify-between modal-header" style={{padding: 0, marginBottom: "1rem", border: 0}}> 
                         {/* className="modal-header"> */}
                            <ul className="nav nav-tabs w-100">
                                <li className="nav-item">
                                    <span className={"nav-link "+(selectedTab === "en" ? "active" : "text-black")} aria-current="page" role="button" onClick={() => setSelectedTab("en")}>English</span>
                                </li>
                                <li className="nav-item">
                                    <span className={"nav-link "+(selectedTab === "it" ? "active" : "text-black")} role="button" onClick={() => setSelectedTab("it")}>Italiano</span>
                                </li>
                                <button type="button" className="btn-close" onClick={e=>{props.closeModal(); setSpell(props.spell);}} aria-label="Close" 
                                    style={{marginTop: "auto", marginBottom: "auto", marginRight: "1rem"}}></button>

                            </ul>
                        </div>
                        <div className="modal-body">
                            
                            <div className={selectedTab === "en" ? "" : "hidden"}>
                                <SpellModalTab spell={spell} setSpell={setSpell} language="en" />
                            </div>
                            <div className={selectedTab === "it" ? "" : "hidden"}>
                                <SpellModalTab spell={spell} setSpell={setSpell} language="it"/>
                            </div>
                        </div>

                        <div className="modal-footer justify-content-between">
                            <span><button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={e=>{modalDelete()}}>{t("modal-delete")}</button></span>
                            <span>
                                <button type="button" className="btn btn-secondary m-1" data-bs-dismiss="modal" onClick={e=>{props.closeModal();}}>{t("modal-close")}</button>
                                <button type="button" className="btn btn-primary m-1" onClick={modalSave}>{t("modal-save")}</button>
                            </span>
                        </div>

                    </form>
                </div>
            </div>
        </div>}</>
    )


    function modalDelete(){
            let id = props.spell.id;
            if (id){
                deleteSpell(id).then((result) => {
                    if (result >= 200 && result < 300){
                        props.deleteSpell(id);
                        props.closeModal();
                    }
                })
            }
            else{
                props.closeModal();
            }
        }
    
        function modalSave(){
            if (props.spell.id){
                putSpell(spell).then((spell) => {
                    props.updateSpell(spell);
                    props.closeModal();
                })
            }else{
                addSpell(spell).then((spell) => {
                    props.updateSpell(spell);
                    props.closeModal();
                })
            }
          
        }  
}
export default SpellModal;